import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy, Renderer } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'wego-admin',
  template: `
  <div class="admin-role">
    <div [class]="toggleClass" (window:resize)="onResize($event)" >
      <wego-navbar (toggleMenu)="ToggleMenuLocal()"></wego-navbar>
      <wego-sidebar [menu]="menu"></wego-sidebar>
      <wego-content-wrapper></wego-content-wrapper>
      <wego-footer></wego-footer>
    </div>
  </div>
  `,
})

export class WegoAdminComponent implements OnInit, OnDestroy {
  toggleClass: string = "ui-skins sidebar-mini";
  menu: any = [
    {
      title: 'LblDashboard',
      icon: 'fa fa-tachometer fa-fw',
      redirectPath: 'dashboard',
    },
    {
      title: 'LblCustomer',
      icon: 'fa fa-user-circle fa-fw',
      redirectPath: 'customer/list',
    },
    {
      title: 'LblRoleManagement',
      icon: 'fa fa-cogs fa-fw',
      redirectPath: 'role/list',
    },
    {
      title: 'LblInstance',
      icon: 'fa fa-bolt fa-fw',
      redirectPath: 'instance/list',
    },
    {
      title: 'LblBranding',
      icon: 'fa fa-tag fa-fw',
      redirectPath: 'branding',
    },
    {
      title: 'LblPersons',
      icon: 'fa fa-user fa-fw',
      redirectPath: 'person/list',
      items: [{
        title: 'LblPersonOverview',
        icon: '',
        redirectPath: 'person/list',
      },
      {
        title: 'LblWegoAdmins',
        icon: '',
        redirectPath: 'wegoadminlist/list',
      }
      ]
    },
    {
      title: 'LblCompanies',
      icon: 'fa fa-building-o fa-fw',
      redirectPath: 'company/list',
    },
    {
      title: 'LblOrganization',
      icon: 'fa fa-sitemap fa-fw',
      redirectPath: 'organization/list',
    },
    {
      title: 'LblVehicles',
      icon: 'fa fa-cab fa-fw',
      redirectPath: 'vehicle/list',
      items: [{
        title: 'LblVehicleOverview',
        icon: '',
        redirectPath: 'vehicle/list',
      },
      {
        title: 'LblVTSVehicleList',
        icon: '',
        redirectPath: 'vtsvehicle/list',
      },
      {
        title: 'LblTroubleShootVTS',
        icon: '',
        redirectPath: 'vtstroubleshoot',
      },
      {
        title: 'LblVehicleAttributeCategories',
        icon: '',
        redirectPath: 'vehicleattributecategory/list',
      }, {
        title: 'LblVehicleAttributes',
        icon: '',
        redirectPath: 'vehicleattribute/list',
      },
      {
        title: 'LblOdometerLogTrail',
        icon: '',
        redirectPath: 'odometerlogtrail/list',
      }
      ]
    },
    {
      title: 'LblSharedVehicleGroups',
      icon: 'fa fa-group fa-fw',
      redirectPath: 'sharedvehiclegroup/list',
      items: [{
        title: 'LblSharedVehicleGroupOverview',
        icon: '',
        redirectPath: 'sharedvehiclegroup/list',
      },
      {
        title: 'LblSpecialPeriods',
        icon: '',
        redirectPath: 'specialperiod/list',
      }
      ]
    },
    {
      title: 'LblDrivers',
      icon: 'fa fa-male fa-fw',
      redirectPath: 'driver/list',
    },
    // {
    //   title: 'LblContractType',
    //   icon: 'fa fa-money fa-fw',
    //   redirectPath: 'contractType/list',
    // },


    {
      title: 'LblBookings',
      icon: 'fa fa-calendar fa-fw',
      redirectPath: 'booking',
      items: [
        {
          title: 'LblBookingsOverview',
          icon: '',
          redirectPath: 'booking/overview',
        },
        {
          title: 'LblNormal',
          icon: '',
          redirectPath: 'booking',
        },
        {
          title: 'LblSpecial',
          icon: '',
          redirectPath: 'specialbooking',
        },
        {
          title: 'LblTripSimulator',
          icon: '',
          redirectPath: 'bookingtriptest',
        },
      ]
    },
    {
      title: 'LblInvoicing',
      icon: 'fa fa-file-text fa-fw',
      redirectPath: 'invoice',
      items: [{
        title: 'LblInvoices',
        icon: '',
        redirectPath: 'invoice/list',
      },
      {
        title: 'LblAdditionalFreeItemsMenu',
        icon: '',
        redirectPath: 'additionalfreeitem/list',
      }]
    },
    // {
    //   title: 'LblServiceOffer',
    //   icon: 'fa fa-star fa-fw',
    //   redirectPath: 'serviceoffer/list',
    // },
    {
      title: 'LblReports',
      icon: 'fa fa-file-o fa-fw',
      redirectPath: 'tripdetailreport',
      items: [{
        title: 'LblVehicleOccupancyReport',
        icon: '',
        redirectPath: 'report/vehicleoccupancy',
      },
      {
        title: 'LblRevenuePerVehicleReport',
        icon: '',
        redirectPath: 'report/revenuepervehiclereport',
      },
      {
        title: 'LblTripDataReport',
        icon: '',
        redirectPath: 'tripdatareport/tripdatareport',
      }, {
        title: 'LblMaintenancePlanningreport',
        icon: '',
        redirectPath: 'report/maintenanceplanningreport',
      }, {
        title: 'LblSnailTrailReport',
        icon: '',
        redirectPath: 'report/snailtrail',
      }, {
        title: 'LblKickbackReport',
        icon: '',
        redirectPath: 'report/kickback',
      },
      {
        title: 'LblCostCenterReport',
        icon: '',
        redirectPath: 'report/costcenterreport'
      }]
    },
    {
      title: 'LblTemplates',
      icon: 'fa fa-file-code-o fa-fw',
      redirectPath: 'template/list',
    },
    {
      title: 'LblSignupForms',
      icon: 'fa fa-pencil-square-o fa-fw',
      redirectPath: 'signupform/list',
      items: [{
        title: 'LblSignupFormsOverview',
        icon: '',
        redirectPath: 'signupform/list',
      },
      {
        title: 'LblSignupsOverView',
        icon: '',
        redirectPath: 'signup/list',
      }]
    },
    {
      title: 'LblEventViewer',
      icon: 'fa fa-file-text-o fa-fw',
      redirectPath: 'eventviewer',
    },
    {
      title: 'LblPrePostTripSetting',
      icon: '',
      redirectPath: 'preposttripquestion'
    }
    // {
    //   title: 'LblSubscription',
    //   icon: 'fa fa-envelope fa-fw',
    //   redirectPath: 'subscription/list',
    // },

    // {
    //   title: 'LblNotificationEvent',
    //   icon: 'fa fa-envelope-o fa-fw',
    //   redirectPath: 'notificationevent',
    // }
  ];

  constructor(private translate: TranslateService
    , private authService: AuthService
    , private renderer: Renderer) { }

  ngOnInit() {
    this.translate.setDetectedLang();
  }

  public ToggleMenuLocal() {
    if (window.innerWidth > 767) {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
        this.toggleClass = "ui-skins sidebar-mini";
    }
    else {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-open";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
        this.toggleClass = "ui-skins sidebar-mini";
    }
    // this.ApplyActiveMenuStyle();
    // setTimeout(() => this.ApplyActiveMenuStyle(), 1000);
  }

  onResize(event: any) {
    // console.log(event);
    // console.log("width:" + event.target.innerWidth);
    // console.log("height:" + event.target.innerHeight);
  }

  // private ApplyActiveMenuStyle() {
  //   let isReset = this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" ? false : true;
  //   let defaultBackgroundColor: string = isReset ? null : "#303F9F";
  //   let defaultTextColor: string = isReset ? null : "#FE4080";
  //   let listToggle = document.querySelectorAll('.sidebar-menu>li>a>span:not(.pull-right)');
  //   if (listToggle) {
  //     for (var i = 0; i < listToggle.length; i++) {
  //       this.renderer.setElementStyle(listToggle[i], 'background-color', defaultBackgroundColor);
  //       this.renderer.setElementStyle(listToggle[i], 'color', defaultTextColor);
  //     }
  //   }

  //   let listTreeViewMenu = document.querySelectorAll('.sidebar-menu>li>.treeview-menu');
  //   if (listTreeViewMenu) {
  //     for (var i = 0; i < listTreeViewMenu.length; i++) {
  //       this.renderer.setElementStyle(listTreeViewMenu[i], 'background-color', defaultBackgroundColor);
  //       // this.renderer.setElementStyle(listTreeViewMenu[i], 'color', defaultTextColor);
  //     }
  //   }

  //   let listTreeViewMenuAnchorText = document.querySelectorAll('.sidebar-menu>li>.treeview-menu li a');
  //   if (listTreeViewMenuAnchorText) {
  //     for (var i = 0; i < listTreeViewMenuAnchorText.length; i++) {
  //       //this.renderer.setElementStyle(listTreeViewMenuAnchorText[i], 'background-color', defaultBackgroundColor);
  //       this.renderer.setElementStyle(listTreeViewMenuAnchorText[i], 'color', defaultTextColor);
  //     }
  //   }
  // }

  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role/components/wegoadmin.component.ts